<po-page-default p-title="Balancete - Conferencia Saldo" [p-breadcrumb]="breadcrumb"
    p-subtitle="Gere o relatório de Balancete baseado nas informações da base de dados do sistema Domínio.">

    <!-- Resumo da página -->
    <div class="page-summary">
        <div class="page-summary-icon">
            <i class="an an-scales"></i>
        </div>
        <div class="page-summary-text">
            <p class="po-font-subtitle po-mb-0">Balancete - Conferencia Saldo</p>
            <p class="page-summary-hint">
                Selecione uma empresa, envie uma planilha com o grupo ou deixe vazio para todas.
                Informe as contas e o período; o relatório será enviado por e-mail.
            </p>
        </div>
    </div>

    <po-divider></po-divider>

    <form #form="ngForm" (ngSubmit)="requestBalancete(form)">

        <!-- Seção: Configurações -->
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-gear-six"></i>
                <span>Configurações do Relatório</span>
            </div>
            <div class="rpt-section-body">
                <div class="rpt-destaque po-mb-3">
                    <p class="po-mb-1"><b>Uma empresa:</b> selecione no campo abaixo (consulta individual).</p>
                    <p class="po-mb-1">
                        <b>Grupo de empresas:</b> envie planilha CSV, XLSX ou XLS com os códigos.
                        <a href="/assets/modelo/Modelo.xlsx" download="Modelo.xlsx" class="rpt-link-modelo">Baixe o modelo</a>
                    </p>
                    <p class="po-mb-1"><b>Todas as empresas:</b> deixe o campo de empresa vazio e sem planilha.</p>
                </div>

                <div class="po-row">
                    <app-empresa-combo
                        class="po-lg-5 po-md-6 po-sm-12"
                        name="empresaId"
                        [(ngModel)]="empresaId"
                        (ngModelChange)="onEmpresaChange()"
                        label="Empresa (opcional)"
                        [required]="false"
                        [disabled]="!!arquivoPlanilha"
                        placeholder="Buscar por código Domínio (codi_emp) ou nome..."
                        help="Código da empresa no Domínio. Vazio = todas.">
                    </app-empresa-combo>

                    <div class="po-lg-5 po-md-6 po-sm-12 planilha-col">
                        <label class="po-field-title">Planilha de empresas (CSV/XLSX/XLS)</label>
                        <div
                            class="dropzone"
                            [class.dropzone-disabled]="!!empresaId"
                            (drop)="onDropArquivo($event)"
                            (dragover)="onDragOverArquivo($event)">
                            Arraste o arquivo aqui ou
                            <input
                                type="file"
                                accept=".csv,.xlsx,.xls"
                                [disabled]="!!empresaId"
                                (change)="onArquivoSelecionado($event)" />
                        </div>
                        <p class="po-font-text arquivo-info" *ngIf="arquivoNome">
                            Arquivo: <b>{{ arquivoNome }}</b>
                            <a class="rpt-link-limpar" (click)="limparArquivo()">Limpar</a>
                        </p>
                    </div>
                </div>

                <div class="po-row po-mt-2">
                    <po-input class="po-lg-4 po-md-6 po-sm-12" p-label="Conta Reduzida Inicial" name="contaInicial" p-pattern="^\d+$"
                        p-icon="an an-currency-circle-dollar" [(ngModel)]="contaInicial"
                        p-placeholder="Ex.: 1"
                        p-help="Código reduzido inicial"
                        p-required="true" p-name="contaInicial">
                    </po-input>
                    <po-input class="po-lg-4 po-md-6 po-sm-12" name="contaFinal" p-pattern="^\d+$" [(ngModel)]="contaFinal"
                        p-icon="an an-currency-circle-dollar" p-label="Conta Reduzida Final"
                        p-placeholder="Ex.: 999"
                        p-help="Código reduzido final" p-required="true"
                        p-name="contaFinal">
                    </po-input>
                    <po-datepicker-range class="po-lg-4 po-md-6 po-sm-12" p-label="Período" p-name="periodo"
                        name="periodo" [(ngModel)]="periodo" p-placeholder-start="Data Inicial"
                        p-placeholder-end="Data Final" p-help="Informe o período desejado para o relatório"
                        [p-required]="true">
                    </po-datepicker-range>
                </div>

                <div class="rpt-action-row po-mt-3">
                    <po-button p-label="Gerar Balancete" p-icon="an an-paper-plane-tilt"
                        (p-click)="requestBalancete(form)" [p-loading]="isLoading">
                    </po-button>
                </div>
            </div>
        </div>

        <!-- Seção: Como funciona -->
        <div class="rpt-section po-mt-3">
            <div class="rpt-section-header">
                <i class="an an-info"></i>
                <span>Como funciona</span>
            </div>
            <div class="rpt-section-body">
                <div class="rpt-info-steps">
                    <div class="rpt-info-step">
                        <div class="rpt-step-number">1</div>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Defina as empresas</p>
                            <p class="rpt-step-desc">Escolha uma empresa no combo, envie planilha com o grupo, ou deixe vazio para todas.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <div class="rpt-step-number">2</div>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Informe contas e período</p>
                            <p class="rpt-step-desc">Informe o intervalo de contas reduzidas e o período desejado.</p>
                        </div>
                    </div>
                    <div class="rpt-info-step">
                        <div class="rpt-step-number">3</div>
                        <div class="rpt-step-content">
                            <p class="rpt-step-title">Receba por e-mail</p>
                            <p class="rpt-step-desc">Após o processamento, o relatório será enviado para o e-mail cadastrado em seu usuário.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</po-page-default>
